export default __webpack_public_path__ + "static/AdobeExpCloudStory-f123f59ba77dfdcd7d3599d5f793f0c3.pdf";